import { Request } from '@/classes/Request'

/**
 * Charge a saved funding source against the enrollment Quickpay cart,
 * token-authenticated. Returns the raw response (snake_case) — the receipt
 * shape matches the wallet quickpay endpoints, which the receipt templates
 * render with snake_case keys (order_id, formatted_totals, ...).
 * POST /api/enrollment/invitation/{token}/quickpay/{guid}/funding-source
 */
export const enrollmentFundingSourcePay = async (
  token: string,
  guid: string,
  fundingSourceId: number
): Promise<any> => {
  const response = await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/quickpay/${encodeURIComponent(
      guid
    )}/funding-source`,
    { funding_source_id: fundingSourceId }
  )
  return response.data
}
